<script>
export default {
  data () {
    return {
      picCode: '',
      picKey: '',
      seconds: 60,
      timer: null,
      userphone: '',
      password: '',
      otherQuery: {}
    }
  },
  created() {
    // 检查是否已经登录，如果已登录则直接跳转
    const token = this.$store.getters.token
    if (token) {
      // 尝试获取用户信息
      this.$store.dispatch('user/getInfo').then(() => {
        // 获取成功，跳转到首页
        this.$router.push({ path: '/' })
      }).catch(() => {
        // 获取失败，清除token
        this.$store.dispatch('user/resetToken')
      })
    }
  },
  name: 'loginIndex', 
  methods: {
    validFn () {
      if (!/^1[3-9]\d{9}$/.test(this.userphone)) {
        this.$toast('请输入正确的手机号')
        return false
      }
      if (!this.password) {
        this.$toast('请输入密码')
        return false
      }
      return true
    },
    async login () {
      if (!this.validFn()) {
        return
      } 
      
      this.$store.dispatch('user/login', {
        phone: this.userphone,
        password: this.password
      }).then(async ({ code,msg }) => { 
        if (code == 200) {
          console.log('准备跳转到/my页面')
          try {
            // 先确保用户信息已加载
            await this.$store.dispatch('user/getInfo')
            // 获取未读消息数量
            await this.$store.dispatch('user/getUnreadMessageCount')
            // 然后执行跳转
            this.$router.push({ path: '/' }).then(() => {
              console.log('跳转成功')
            }).catch((err) => {
              console.error('跳转失败:', err)
            })
          } catch (error) {
            console.error('获取用户信息失败:', error)
            // 判断error是否为对象，是的话读取msg作为提示信息，否则使用默认提示
            const errorMessage = error && typeof error === 'object' && error.msg ? error.msg : '获取用户信息失败，请重新登录'
            this.$toast(errorMessage)
          }
        } else { 
          this.$toast(msg || '登录失败')
        }
      }).catch((err) => {
        this.$toast('登录失败')
        console.error('登录失败:', err)
      }) 
    }, 
    // 找回密码
    onFindPassword() {
      this.$router.push('/login/forgetPwd')
    },
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<template>
    <div class="login">
      <van-nav-bar title="轩妈竞价系统"  />
      <div class="container">
        <div class="title">
          <img src="@/assets/logo.png" alt="">
          <p>欢迎回来，请登录您的账号</p>
        </div>

        <div class="form">
          <div class="form-item">
            <div class="input-wrapper">
              <span class="icon">📱</span>
              <input v-model="userphone" class="inp" maxlength="11" placeholder="请输入手机号码" type="text">
            </div>
          </div>
          <div class="form-item">
            <div class="input-wrapper">
              <span class="icon">🔒</span>
              <input v-model="password" class="inp" placeholder="请输入密码" type="password">
            </div>
          </div>
          <div class="forgot-password">
            <span @click="onFindPassword">找回密码</span>
          </div>
        </div>

        <div @click="login" class="login-btn">
          <span>登录</span>
        </div>
        
        <div class="tips">
          <!-- <p>登录即表示同意 <span class="link">用户协议</span> 和 <span class="link">隐私政策</span></p> -->
        </div>
      </div>
    </div>
</template>

<style lang="less" scoped>
@primary-color: #ff6b6b;
@primary-gradient: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
@text-primary: #333;
@text-secondary: #888;
@bg-color: #f5f7fa;

// 整体容器优化
.container {
  padding: 40px 24px;
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;

  .title {
    margin-bottom: 32px;
    text-align: center;
    
    img {
      width: 60%;
    }
    
    p {
      margin-top: -6px;
      font-size: 14px;
      color: @text-secondary;
    }
  }

  .form {
    flex: 1;
    
    .form-item {
      margin-bottom: 16px;
      
      .input-wrapper {
        background: #fff;
        border-radius: 12px;
        padding: 4px 16px;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        border: 1px solid #eee;
        transition: all 0.3s ease;
        
        &:focus-within {
          border-color: @primary-color;
          box-shadow: 0 4px 12px rgba(255, 107, 107, 0.15);
        }
        
        .icon {
          font-size: 16px;
          margin-right: 12px;
          opacity: 0.6;
        }
        
        .inp {
          display: block;
          border: none;
          outline: none;
          height: 48px;
          font-size: 15px;
          flex: 1;
          color: @text-primary;
          background: transparent;
          
          &::placeholder {
            color: #bbb;
          }
        }
      }
    }
    .forgot-password { 
      text-align: right;
      margin: 8px 8px 0 0;
      font-size: 14px;
      color: #888;
    }
  }

  .login-btn {
    width: 100%;
    margin-top: 24px;
    background: @primary-gradient;
    color: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(255, 107, 107, 0.3);
    letter-spacing: 2px;
    font-size: 16px;
    padding: 14px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    
    span {
      position: relative;
      z-index: 1;
    }
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
    }
  }
  
  .tips {
    margin-top: 24px;
    text-align: center;
    
    p {
      font-size: 12px;
      color: #999;
      line-height: 1.6;
      
      .link {
        color: @primary-color;
        cursor: pointer;
        
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

// 登录页面整体背景
.login {
  min-height: 100vh;
  background: @bg-color;
  
  :deep(.van-nav-bar) {
    background: @primary-gradient;
    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.2);
    
    .van-nav-bar__title {
      color: #fff;
      font-weight: 600;
    }
    
    .van-icon {
      color: #fff;
    }
  }
}
</style>


